import React, { useState } from 'react';
import { usePro } from '../contexts/ProContext';
import { useTheme } from '../theme';
import UpgradeModal from './UpgradeModal';
import { HiOutlineLockClosed } from 'react-icons/hi';

export default function ProGate({ children, feature = 'this feature' }) {
  const { isPro } = usePro();
  const { colors, dark } = useTheme();
  const [showUpgrade, setShowUpgrade] = useState(false);

  if (isPro) return <>{children}</>;

  return (
    <>
      <div style={{ position: 'relative' }}>
        {/* Static placeholder skeleton instead of rendering real children */}
        <div style={{
          filter: 'blur(6px)',
          opacity: 0.5,
          pointerEvents: 'none',
          userSelect: 'none',
        }}>
          <div style={{ padding: 24 }}>
            <div style={{ height: 24, width: '60%', background: dark ? 'rgba(255,255,255,0.08)' : '#E8EAED', borderRadius: 6, marginBottom: 16 }} />
            <div style={{ height: 14, width: '90%', background: dark ? 'rgba(255,255,255,0.05)' : '#F0F0F0', borderRadius: 4, marginBottom: 10 }} />
            <div style={{ height: 14, width: '75%', background: dark ? 'rgba(255,255,255,0.05)' : '#F0F0F0', borderRadius: 4, marginBottom: 10 }} />
            <div style={{ height: 14, width: '80%', background: dark ? 'rgba(255,255,255,0.05)' : '#F0F0F0', borderRadius: 4, marginBottom: 20 }} />
            <div style={{ display: 'flex', gap: 12 }}>
              <div style={{ height: 80, flex: 1, background: dark ? 'rgba(255,255,255,0.05)' : '#F4F5F6', borderRadius: 8 }} />
              <div style={{ height: 80, flex: 1, background: dark ? 'rgba(255,255,255,0.05)' : '#F4F5F6', borderRadius: 8 }} />
              <div style={{ height: 80, flex: 1, background: dark ? 'rgba(255,255,255,0.05)' : '#F4F5F6', borderRadius: 8 }} />
            </div>
          </div>
        </div>

        {/* Overlay */}
        <div style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: dark
            ? 'radial-gradient(ellipse at center, rgba(138,106,0,0.08) 0%, rgba(0,0,0,0.4) 100%)'
            : 'radial-gradient(ellipse at center, rgba(138,106,0,0.04) 0%, rgba(255,255,255,0.7) 100%)',
          borderRadius: 12,
          zIndex: 10,
        }}>
          <div style={{
            background: dark ? colors.surface : '#FFFFFF',
            borderRadius: 14,
            border: `1px solid ${dark ? 'rgba(138,106,0,0.3)' : '#E0CC70'}`,
            boxShadow: '0 8px 32px rgba(138,106,0,0.15)',
            padding: '28px 36px',
            textAlign: 'center',
            maxWidth: 320,
          }}>
            <div style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: dark ? 'rgba(138,106,0,0.15)' : '#FFF8E0',
              border: `1px solid ${dark ? 'rgba(138,106,0,0.3)' : '#E0CC70'}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px',
            }}>
              <HiOutlineLockClosed size={22} style={{ color: '#8A6A00' }} />
            </div>
            <div style={{
              fontFamily: "'DM Serif Display', serif",
              fontSize: 18,
              color: colors.textPrimary,
              marginBottom: 8,
            }}>
              Pro Feature
            </div>
            <div style={{
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: 11,
              color: colors.textSecondary,
              lineHeight: 1.5,
              marginBottom: 20,
            }}>
              Unlock {feature} and all Pro tools for <strong style={{ color: '#8A6A00' }}>$9.90/month</strong>
            </div>
            <button
              onClick={() => setShowUpgrade(true)}
              style={{
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 12,
                fontWeight: 700,
                color: '#FFFFFF',
                background: 'linear-gradient(135deg, #8A6A00, #B8941A)',
                border: 'none',
                borderRadius: 8,
                padding: '10px 24px',
                cursor: 'pointer',
                letterSpacing: 0.5,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 6,
              }}
            >
              <span style={{ fontSize: 14 }}>&#x1F451;</span>
              Upgrade to Pro
            </button>
          </div>
        </div>
      </div>
      <UpgradeModal open={showUpgrade} onClose={() => setShowUpgrade(false)} />
    </>
  );
}
